export default "__VITE_ASSET__8eeJORT3__"